module.exports = __webpack_public_path__ + "static/media/icon-settings-hubspot.8f2bc3b6.svg";